import script from "./MobileLeftDrawerNavigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./MobileLeftDrawerNavigation.vue?vue&type=script&lang=ts&setup=true"

import "./MobileLeftDrawerNavigation.vue?vue&type=style&index=0&id=2adf7924&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/klever-front3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2adf7924"]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QToolbar,QItem,QItemSection,QAvatar,QItemLabel,QSeparator,QList});qInstall(script, 'directives', {Ripple});
